import { SyntheticEvent } from 'react';

import { ImageCropData, ImagePicker, ImageState } from './image-crop.constants';

export function prepareCropData(
  imageState: ImageState,
  imagePicker: ImagePicker
): ImageCropData {
  return {
    width: imagePicker.width,
    height: imagePicker.height,
    naturalWidth: imageState.imageWidth,
    naturalHeight: imageState.imageHeight,
    x: Number(imageState.x.toFixed(3)),
    y: Number(imageState.y.toFixed(3)),
    zoom: imageState.zoom,
  };
}

export function getInitialSizeValues(el: SyntheticEvent<HTMLImageElement>) {
  const { naturalWidth, naturalHeight } = el.currentTarget;
  const containerHeight = el.currentTarget.parentElement?.offsetHeight || 0;
  const containerWidth = el.currentTarget.parentElement?.offsetWidth || 0;
  return {
    naturalWidth,
    naturalHeight,
    containerHeight,
    containerWidth,
  };
}

export function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}
